var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultADoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#F7D3BD",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5631 23.1426C25.2379 21.038 23.5869 19.246 22.6 18.8232C22.2254 18.6626 21.8085 18.537 21.4356 18.4429C21.3815 17.6385 20.5799 15.5243 20.9799 12.3947C21.8992 5.20176 10.9124 5.20176 11.8321 12.3947C12.2321 15.5244 11.4304 17.6385 11.3764 18.4429C11.0035 18.537 10.5866 18.6626 10.212 18.8232C9.22508 19.2462 7.57397 21.0382 8.24891 23.1426C9.16995 26.0161 23.6421 26.0161 24.5631 23.1426H24.5631ZM20.3366 20.8742H21.4238V21.7501H22.2998V22.8374H21.4238V23.7134H20.3366V22.8374H19.4606V21.7501H20.3366V20.8742ZM16.4058 21.6899L19.5396 18.4728L18.6788 17.2347C17.5296 18.7247 15.2822 18.7247 14.1327 17.2347L13.2719 18.4728L16.4058 21.6899ZM19.4753 14.8651C19.015 16.5123 17.8146 17.6873 16.4058 17.6873C14.997 17.6873 13.7964 16.5121 13.3363 14.8651C12.7882 14.7067 12.4902 13.7587 12.4125 13.383C12.332 12.9954 12.5134 12.4242 13.1487 12.991C13.195 12.2993 13.3656 11.6547 13.6298 11.0954C14.4478 10.6104 14.7835 10.6763 15.5383 11.0499C16.3872 11.469 19.0939 12.7431 19.6488 13.004C20.295 12.4165 20.4797 12.9933 20.3985 13.3837C20.3207 13.7595 20.0228 14.7075 19.4747 14.8659L19.4753 14.8651Z",
    fill: "#E96B1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultADoctorIcon);
export default __webpack_public_path__ + "static/media/consultADoctorIcon.90e21d1d348ba15435c2cb13f75b6dbf.svg";
export { ForwardRef as ReactComponent };